import React, {memo} from "react";
import {getField} from "./config";
import "./index.scss";


const FormField = ({fieldType, className, ...fieldProps}) => {
    const Field = getField(fieldType);

    return (
        <Field
            className={`form__field${className ? ' ' + className : ''}`}
            {...fieldProps}
        />
    )
};

export default memo(FormField);